/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CirclePile = [
  ["circle", { cx: "12", cy: "19", r: "2" }],
  ["circle", { cx: "12", cy: "5", r: "2" }],
  ["circle", { cx: "16", cy: "12", r: "2" }],
  ["circle", { cx: "20", cy: "19", r: "2" }],
  ["circle", { cx: "4", cy: "19", r: "2" }],
  ["circle", { cx: "8", cy: "12", r: "2" }]
];

export { CirclePile as default };
//# sourceMappingURL=circle-pile.js.map
